import { requestPost } from '../../../modules/request/index';

export const SEARCH_LOGS_PATH = '/search_logs'
export const ACTIVITY_LIBRARY_SEARCH_LOG_SOURCE = 'activity_library'

export interface SearchLogAttributes {
  source: string,
  query: string,
  filters?: Record<string, unknown>,
  resultCount?: number,
  searchSessionUid: string
}

function ignoreResponse() {}

export function logSearch({ source, query, filters = {}, resultCount, searchSessionUid }: SearchLogAttributes) {
  const trimmedQuery = String(query).trim()
  if (!trimmedQuery.length) { return }

  const searchLog = {
    source,
    query: trimmedQuery,
    filters,
    result_count: resultCount,
    search_session_uid: searchSessionUid,
  }
  requestPost(SEARCH_LOGS_PATH, { search_log: searchLog }, ignoreResponse, ignoreResponse)
}
